import styled from 'styled-components';
import { StyledCalendarWrapper } from 'components/PeriodPicker/components/PeriodsSelection/Calendar/Calendar.style';

export const STYLED_DAY_CLASSES = {
  CIRCLE: 'circle',
  FILL: 'fill'
};

export const StyledCalendarDay = styled.div`
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: content-box;

  &.${STYLED_DAY_CLASSES.CIRCLE} {
    & > span {
      box-sizing: content-box;
      margin-left: 0.8rem;
      width: 22px;
      height: 22px;
      line-height: 22px;
      border-radius: 50%;

      border: 3px solid ${props => props.borderColor};
      background: #fff;
    }
  }
  &.${STYLED_DAY_CLASSES.FILL} {
    background-color: ${props => props.backgroundColor};
    &.isFirst {
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    }
    &.isLast {
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
    }
  }
`;

export const StyledCalendar = styled(StyledCalendarWrapper)`
  /*
  using generic td: because versions issues between Prod and Local.
  on Prod, it doesnt append the CalendarDay classname for some reason, so this approach fix that
  */
  td,
  [class*='CalendarDay'] {
    border: none !important;
    padding: 0 !important;
    color: rgba(34, 35, 38) !important;
    &:hover {
      cursor: default !important;
      background: transparent !important;
      color: rgba(34, 35, 38) !important;
      border: none !important;
      font-weight: normal !important;
    }
  }
`;
